module.exports = __webpack_public_path__ + "static/Aaron-98a617fba2d2ffc82db4b3d777a9b15a.jpg";